/** @module Camunda/RefToProcess */
define([
	"dojo/_base/declare",
	"csi/heading/Ref",
	"csi/service/rightPaneService",
	"csi/utility/routerUtility",
], function(declare, Ref, rightPaneService, {LOCATION_RIGHT_PANE, LOCATION_RIGHT_PANE_URL}) {

	return declare(Ref, {
		/** @property {string} contextToProcessInstanceAttrId - attribute Id of context node to get CamundaProcessInstance URL */
		contextToProcessInstanceAttrId: null,

		/**
		 * @override
		 * Get parameters for URL hash to open 'Processes' page
		 */
		onAnchorHashParams(ctx, params) {
			this.inherited(arguments);

			// context node could be CamundaTask or CamundaProcessInstance
			const ctxNode = ctx.getNode();
			const processInstanceUrl = ctxNode[this.contextToProcessInstanceAttrId || "$URL"];
			if (processInstanceUrl) {
				params[LOCATION_RIGHT_PANE] = rightPaneService.PROCESS_ON_INSTANCE;
				params[LOCATION_RIGHT_PANE_URL] = processInstanceUrl;
			}
		},
	});
});